import { Form, FormInstance, Input } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { getMyOrganization, Organization } from "@src/redux/index";

interface Props {
  form: FormInstance;
  className?: string;
  myOrganizationResult?: Organization | null;
}
const OrganizationSelect: React.FC<Props> = (props) => {
  const { className, myOrganizationResult } = props;

  return (
    <Form.Item
      label={myOrganizationResult?.level?.name}
      className={className}
      name={myOrganizationResult?.level?.name}
      initialValue={myOrganizationResult?.name}
    >
      <Input value={myOrganizationResult?.name} disabled={true} />
    </Form.Item>
    
  );
};

export default OrganizationSelect;
